/**
 * Split out of `lib/api/articles.ts` (phase 4a-1, Task 0) so it can be
 * imported from plain Node by the `server/head` service without pulling in
 * that file's own `slugify`/lex-client/logger dependencies. Dependency-free
 * by design - keep it that way.
 */

/**
 * `base + '/' + path` semantics, matching
 * `atproto/packages/bsky/src/util/standard-site.ts`'s own `joinPath` exactly
 * (a leading slash on `path` does NOT swallow `base`'s pathname the way
 * `new URL(path, base)` would) - both sides of the canonicalization Bluesky's
 * card validation performs must agree byte-for-byte, not just resolve to the
 * same URL.
 */
export const joinPath = (base: string, path: string): string => {
  if (!path) return base
  const baseTrimmed = base.endsWith('/') ? base.slice(0, -1) : base
  const pathTrimmed = path.startsWith('/') ? path.slice(1) : path
  return `${baseTrimmed}/${pathTrimmed}`
}
